import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

import list from '@/store/shared/selectableList'

export default {
  namespaced: true,
  state () {
    return {
      numeroRequerimiento: '',
      result: undefined,
      enviadas: [],
      registros: [],
      comprobacion: undefined,
      resultadoExportacion: undefined,
      params: {},
      loaded: false
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    list
  }
}